import React from 'react';
import { HomeContext } from '../../Home/HomeContext';
import { Box, Button, createStyles, Grid, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import { theme } from '../../../theme';
import { PageLocation } from '../../../shared/enum/PageLocation';

interface IlistInfluencerClientEnable {
 id: number |null; id_cliente:number; nome: string;
}
const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        fontWeight:'bold',
        overflow:'hidden',
        color:'white',

    },
    itemUnselected: {
        fontWeight:'bold',
        color: '#757575',
        overflow:'hidden',
        
    },
    title: {
        maxWidth: '730px',
        textAlign: 'center'
    },
    item: {
        margin: '24px',
        maxWidth: '930px',
        textAlign: 'center'
    },
}));


export default function InfluencerClientSelect(){
    const homeContext = React.useContext(HomeContext);
    const classes = useStyles();
    const listInfluencerClientEnable : IlistInfluencerClientEnable | any  = homeContext.influencerListClientEnable;
    
    const handleClick = (item:{id:number,id_cliente:number, nome:string})=>{
        homeContext.setInfluencerClientEnable(item);
        homeContext.setPageLocation(PageLocation.INFLUENCER_HOME);
    };
    return (
        <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
        padding={5}
    >
        <Grid
            direction="column"
            justifyContent="center"
            alignContent='center' 
            
        >
            <Grid
            container 
            direction="column"
            // justifyContent="center"
            alignContent='center' 
            >
                <Typography variant="h4" className={classes.title}>
                Selecione um Cliente
                </Typography>
                <Typography variant="body1" className={classes.item}>
                Selecione um cliente para visualizar informações e ações disponíveis.
                </Typography>
            </Grid>
            <Grid 
            container 
            direction='row' 
            justifyContent="center"
            alignContent='center' 
            spacing={3}
            style={{
                width: '90vw', 
                margin: 0,
            }}
            >
                {listInfluencerClientEnable?.map((item:{id:number, id_cliente:number, nome:string}) => (
                    <Grid item key={item.id} xs={2} sm={2} md={2} lg={2} >
                        <Button
                            variant="contained"
                            color={item.id == homeContext.influencerClientEnable?.id ? 'primary':'default'}
                            className={item.id == homeContext.influencerClientEnable?.id ? classes.itens: classes.itemUnselected }
                            size="large"
                            fullWidth
                            onClick={()=>handleClick(item)}
                            >
                            <Box height={180} width={160} alignContent='center'>
                                <div
                                >
                                    {item.nome}
                                </div>
                            </Box>
                        </Button>
                    </Grid>
                ))}
 
                    
            </Grid>
        </Grid>
    </Box>
    );
}